import * as React from 'react';
import { Routes } from './Routes';
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { initilizeUserInfo, isUserVerified } from 'service/userService'
import { registerInactivityService, unregisterInactivityService } from 'service/inactivityService'
import { msalInstance } from '.';
import UnauthorizedAccess from './Components/Authentication/UnauthorizedAccess';
import Layout from './Components/Layout';
import ProfileValidate from './Components/Authentication/ProfileValidate';
import { AuthenticationResult, EventMessage, EventType, LogLevel, PublicClientApplication } from "@azure/msal-browser";

/**
 * Sandeep: Initilize user info and set the cache for the user by utilizing the received access token.
 */
class App extends React.Component {

    constructor(props: any) {
        super(props)
    }

    state = {
        initilized: false,
        authorized: true,
        authorizedToHome: true,
    }

    /**
     * Sandeep: Get and cache user information in local storage for UI use.
     * we are ensuring all keys to be encrypted while getting the information.
     */
    componentDidMount = async () => {
        await initilizeUserInfo(this.initRender);
        registerInactivityService();
    }

    componentWillUnmount() {
        unregisterInactivityService();
    }

    /**
     * Sandeep: Callback method to render the UI after the token is received and set to cache.
     */
    initRender = (status: string) => {
        if (status == '200')
            this.setState({ initilized: true });
        else if (status == '401')
            this.setState({ authorized: false });
    }

    //SS: Log out unauthorize user and display prompt.
    logOutUnauthorizedUser = () => {
        msalInstance.logout();
    }

    /**
     * Render the UI.
     * @returns
     */
    render() {
        return <>
            {
                (this.state.initilized ?
                    <Layout><Routes /></Layout> :
                    this.state.authorized ? <div className="loading d-flex justify-content-center align-items-center">
                        <span className="loader3">Trailboss</span>
                    </div> :
                        <UnauthorizedAccess />)
            }
        </>
    }
};

export default App;
